<div class="card user-card">
  <div class="card-header">
    <h5>uMuzi | Community</h5>
  </div>
  <div class="card-block">
    <div>
      <img
        *ngIf="community.image"
        [src]="community.image"
        class="community-img"
        alt="Community-Image"
      />
      <img
        *ngIf="!community.image"
        [src]="defaultCommunityImg"
        class="community-img"
        alt="Community-Image"
      />
    </div>
    <h6 class="f-w-600 m-t-25 m-b-10">{{ community.name }}</h6>
    <p class="text-muted create-date">
      Created {{ community.createdAt | date: "longDate":"UTC" }}
    </p>
    <div>
      <button
        [routerLink]="['/community-editor', community.name]"
        [hidden]="!isFounder"
        type="button"
        class="btn btn-primary"
      >
        <i class="icofont icofont-ui-settings"></i> Edit this uMuzi
      </button>
    </div>

    <div class="bg-c-blue counter-block m-t-10 p-20">
      <div class="row">
        <div class="col-4" *ngIf="community.discussionCount">
          <i class="ti-microphone"></i>
          <p>{{ community.discussionCount }}</p>
          <p>nDabas</p>
        </div>
        <div class="col-4" *ngIf="community.memberCount">
          <i class="ti-user"></i>
          <p>{{ community.memberCount }}</p>
          <p>Members</p>
        </div>
        <div class="col-4" *ngIf="community.isMember">
          <i class="ti-unlock"></i>
          <p>&nbsp;</p>
          <p>Are a member</p>
        </div>
        <div class="col-4" *ngIf="!community.isMember">
          <i class="ti-lock"></i>
          <p>&nbsp;</p>
          <p>Not a member</p>
        </div>
      </div>
    </div>
    <p
      [innerHTML]="community.summary"
      class="f-w-600 m-t-25 m-b-10 text-left"
    ></p>
    <p
      [innerHTML]="community.description"
      class="m-t-15 text-muted text-left"
    ></p>
  </div>

  <hr />

  <div class="media community-founder">
    <!-- Discussion Author image start -->
    <a
      class="media-left media-middle"
      [routerLink]="['/profile', community.founder.username]"
    >
      <img
        *ngIf="community.founder.image"
        class="community-founder-img"
        [src]="community.founder.image"
        alt="community-founder-img"
      />
      <img
        *ngIf="!community.founder.image"
        class="community-founder-img"
        [src]="defaultUserImg"
        alt="community-founder-img"
      />
    </a>
    <!-- Discussion author image end -->

    <div class="media-body media-middle">
      <div class="company-name">
        <span class="text-muted f-14">Founded by: </span>

        <!-- Community author name start -->
        <a [routerLink]="['/profile', community.founder.username]">
          <p>{{ community.founder.username | slice: 0:30 }}</p>
        </a>
        <!-- Community author name end -->
      </div>
    </div>
  </div>
</div>

<div class="card user-card">
  <div class="card-header">
    <h5>Invites</h5>
  </div>

  <div class="invite-to-community-section">
    <button
      *ngIf="!community.isMember || community.isMember === null"
      type="button"
      class="btn btn-primary invite-to-community-button"
      (click)="joinCommunityAlert()"
    >
      <i class="icofont icofont-plus"></i>
      <i class="icofont icofont-user-alt-2"></i>
      Join
    </button>

    <invite-to-community-button [community]="community">
    </invite-to-community-button>
  </div>
</div>

<div
  class="card user-card"
  *ngIf="currentUser.username && community.name !== 'uMuzi'"
>
  <div class="card-header">
    <h5>View members</h5>
  </div>

  <div class="community-member-section" *showAuthed="true">
    <div class="community-members-button">
      <!-- Community-members-modal -->
      <show-members-button [community]="community" [limit]="3" [config]="{}">
      </show-members-button>
      <!-- Community-members-modal -->
    </div>
  </div>
</div>

<!-- delete membership button -->
<div
  class="card user-card"
  *ngIf="community && community.isMember && community.name !== 'uMuzi'"
>
  <div class="card-header">
    <h5>Leave this community</h5>
  </div>

  <div class="leave-community-section">
    <del-membership-button [currentUser]="currentUser" [community]="community">
    </del-membership-button>
  </div>
</div>
<!-- delete membership button -->

<!-- Community-tags-start -->
<div class="card stop-overflow" *ngIf="community.tagList.length > 0">
  <div class="card-header">
    <h5 class="card-header-text">
      <i class="icofont icofont-tags m-r-10"></i>Community tags
    </h5>
  </div>
  <div class="card-body">
    <!-- start tagList -->
    <div class="j-span12 j-unit">
      <span *ngFor="let tag of community.tagList">
        <label class="j-span2 label label-lg label-primary tagList">
          {{ tag | slice: 0:20 }}
        </label>
      </span>
    </div>
    <!-- end tagList -->
  </div>
</div>
<!-- Community-tags-end -->
